import { render } from "./PersistentPlayer.vue?vue&type=template&id=21111ae1"
import script from "./PersistentPlayer.vue?vue&type=script&lang=js"
export * from "./PersistentPlayer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__